import { render, staticRenderFns } from "./indexOther.vue?vue&type=template&id=a6532058&scoped=true&"
import script from "./indexOther.vue?vue&type=script&lang=js&"
export * from "./indexOther.vue?vue&type=script&lang=js&"
import style0 from "./indexOther.vue?vue&type=style&index=0&id=a6532058&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6532058",
  null
  
)

export default component.exports